import {enUS as en, nl} from "date-fns/locale";


const localeObj = {
    "nl": nl,
    "en": en
}

export const getLanguage = (userLang) => {

    if (userLang === "en" || userLang === "nl") {
        return localeObj[userLang]
    } else return nl;

}


export const replaceAtSymbol = (email) => {
    if (typeof email === 'string') {
        return email.replace(/@/g, '_');
    } else {

        return email;
    }
}
